import { Select } from "antd";
import { DownOutlined } from "@ant-design/icons";

function AppSelect({
  onChange,
  onSearch,
  onBlur,
  onKeyDown,
  showSearch,
  optionFilterProp,
  value,
  label,
  placeholder,
  name,
  options,
  prefix,
  suffix,
  onClear,
  allowClear,
  required,
  className = "",
  containerClassName = "",
  labelClassName = "",
  requiredClassName = "",
  disabled,
  labelExtra,
  error,
  width,
  loading = false,
  classNames = "",
  popupClassName = "",
  getPopupContainer = "",
  ...props
}) {
  return (
    <div className={`common-input-box ${containerClassName}`}>
      {label && (
        <label htmlFor={name} className={`app-label ${labelClassName}`}>
          <div>
            {label}
            {required && (
              <span className={`required ${requiredClassName}`}>*</span>
            )}
          </div>
          {labelExtra && (
            <span style={{ color: "#64748b", fontSize: 12, marginLeft: 6 }}>
              {labelExtra}
            </span>
          )}
        </label>
      )}

      <Select
        aria-label={label}
        required={required}
        className={`common-select ${className}`}
        placeholder={placeholder}
        classNames={`common-select-options ${classNames}`}
        value={value ?? undefined}
        name={name}
        allowClear={allowClear}
        disabled={disabled}
        style={{ width }}
        onClear={onClear}
        showSearch={!!showSearch}
        optionFilterProp={optionFilterProp}
        suffixIcon={loading ? undefined : <DownOutlined style={{ fontSize: 12 }} />}
        onChange={(selected, option) => onChange?.(selected, option)}
        onSearch={onSearch ? (v) => onSearch(v) : undefined}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        prefix={prefix}
        suffix={suffix}
        getPopupContainer={getPopupContainer}
        popupClassName={popupClassName}
        {...props}
        options={options}
        loading={loading}
      />

      {error && <div className="error-message">{error}</div>}
    </div>
  );
}

export default AppSelect;
